export default function ga() {
    let onClickTabPhone = false
    let onClickTabEmail = false
    let changeEmail = false
    let changePhone = false
    let changePsw = false
    let onClickMainBtn = false
    let onClickLoginBtn = false
    let successRegister = true

    document.querySelector('#tabPhone').addEventListener('click', ()=>{
        if(onClickTabPhone) return
        onClickTabPhone = true
        dataLayer.push ({
            'event':'click_button',                  
            'button_name':'phone',                   
            'location':'registration' 
        })
    })
    document.querySelector('#tabEmail').addEventListener('click', ()=>{
        if(onClickTabEmail) return
        onClickTabEmail = true
        dataLayer.push ({
            'event':'click_button',                  
            'button_name':'email',                   
            'location':'registration' 
        })
    })
    document.querySelector('#RegisterForm_contact').addEventListener('keydown', ()=>{
        const inputType = document.querySelector('#RegisterForm_contact').getAttribute('type')
        if(inputType === 'tel' && !changePhone) {
            setTimeout(()=>{
                const inputValue = document.querySelector('#RegisterForm_contact').value
                if(inputValue !== '+380') {
                    changePhone = true
                    dataLayer.push ({
                      'event': 'change_form',
                      'form_name': 'registration',
                      'form_field': 'phone',
                      'location': 'phone'
                    })
                }
            }, 100)
        } else if(inputType === 'email' && !changeEmail) {
            changeEmail = true
            dataLayer.push ({
                'event': 'change_form',
                'form_name': 'registration',
                'form_field': 'email',
                'location': 'email'
            })
        }
    })
    document.querySelector('#RegisterForm_password').addEventListener('keydown', ()=>{
        if(changePsw) return
        changePsw = true
        const inputType = document.querySelector('#RegisterForm_contact').getAttribute('type')
        dataLayer.push ({
            'event': 'change_form',
            'form_name': 'registration',
            'form_field': 'password',
            'location': inputType === 'tel' ? 'phone' : 'email' 
        })        
    })
    document.querySelector('#register').addEventListener('click', ()=>{
        if(onClickMainBtn) return
        onClickMainBtn = true
        dataLayer.push ({
            'event':'click_button',                  
            'button_name':'get offer',                   
            'location':'registration' 
        })            
    })
    document.querySelector('#loginBtn').addEventListener('click', ()=>{
        if(onClickLoginBtn) return
        onClickLoginBtn = true
        dataLayer.push ({
          'event':'click_button',                  
          'button_name':'login',                   
          'location':'registration' 
        })            
    })
    document.addEventListener("successSend", ()=> {
        if(successRegister) {
            const type = document.querySelector('#RegisterForm_contact').type;
            dataLayer.push ({'event':'registration', 'step':'success', 'type': type, 'location':'header'})
            successRegister = false
        }
    })
}